import { render, staticRenderFns } from "./CareerPath.vue?vue&type=template&id=27b25c17&scoped=true"
import script from "./CareerPath.vue?vue&type=script&lang=ts"
export * from "./CareerPath.vue?vue&type=script&lang=ts"
import style0 from "./CareerPath.vue?vue&type=style&index=0&id=27b25c17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b25c17",
  null
  
)

export default component.exports